import { render, staticRenderFns } from "./TestimonialForm.vue?vue&type=template&id=cb2a6ec6&"
import script from "./TestimonialForm.vue?vue&type=script&lang=js&"
export * from "./TestimonialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports